const normalizeSrc = (src) => (src.startsWith('/') ? src.slice(1) : src);

const optimizableUrls = ['https://storage.googleapis.com/', 'https://cdn.jucy.com/', 'https://cdn.test.jucy.com/', 'https://image.mux.com/'];

export default function cloudflareLoader({ src, width, quality, format }) {
    const normalizedSrc = normalizeSrc(src);
    if (src.includes('_next/')) {
        return src
    }
    if (src.startsWith('http') && !optimizableUrls.some((url) => src.startsWith(url))) {
        return src;
    }

    const params = [`width=${width}`, `format=${format || 'auto'}`];
    if (quality) {
        params.push(`quality=${quality}`);
    }

    const paramsString = params.join(',');

    return `https://cdn.jucy.com/cdn-cgi/image/${paramsString}/${normalizedSrc}`;
}
